import { useEffect, useMemo, useRef, useState } from "react";

const MONTHS = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export default function MonthPicker({ value, onChange, year }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const months = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const selectedYear = Number(year);

    return MONTHS.filter((item) => {
      if (selectedYear < currentYear) return true;
      if (selectedYear > currentYear) return false;
      return Number(item.value) <= currentMonth;
    });
  }, [year]);

  const selectedLabel = useMemo(() => {
    const match = MONTHS.find((item) => item.value === String(value));
    return match?.label ?? "Select month";
  }, [value]);

  useEffect(() => {
    if (!open) return undefined;

    const close = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", close);
    document.addEventListener("touchstart", close);
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("touchstart", close);
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open]);

  const pickMonth = (monthValue) => {
    onChange(monthValue);
    setOpen(false);
  };

  return (
    <div className="dash-year-picker dash-year-picker--month" ref={rootRef}>
      <button
        type="button"
        className="dash-year-picker__btn dash-year-picker__btn--month"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label="Select month"
      >
        <span>{selectedLabel}</span>
        <i className={`fas fa-chevron-down dash-year-picker__chev${open ? " is-open" : ""}`} />
      </button>

      {open && (
        <>
          <button
            type="button"
            className="dash-year-picker__backdrop"
            aria-label="Close month picker"
            onClick={() => setOpen(false)}
          />
          <div className="dash-year-picker__sheet" role="listbox" aria-label="Month options">
            <div className="dash-year-picker__sheet-head">
              <span>Select Month</span>
              <button type="button" className="dash-year-picker__close" onClick={() => setOpen(false)}>
                <i className="fas fa-times" />
              </button>
            </div>
            <ul className="dash-year-picker__list">
              {months.map((item) => (
                <li key={item.value}>
                  <button
                    type="button"
                    role="option"
                    aria-selected={item.value === String(value)}
                    className={`dash-year-picker__option${item.value === String(value) ? " is-active" : ""}`}
                    onClick={() => pickMonth(item.value)}
                  >
                    {item.label}
                    {item.value === String(value) && <i className="fas fa-check" />}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
}
